module.exports = __webpack_public_path__ + "static/media/emj06.c13be7ed.svg";